import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getAllPrograms } from "../../../../../store/slices/programsSlice";
import FeatherIcon from "feather-icons-react";
import {
  createSubServiceMapping,
  deleteSubServiceMapping,
  getAllSubServices,
} from "../../../../../store/slices/subServicesSlice";
import {
  createPrgramServiceMapping,
  deletePrgramServiceMapping,
  getAllServices,
  subServiceImgUpload,
} from "../../../../../store/slices/servicesSlice";

import Select from "react-select";
import { Btn, H5 } from "../../../../../AbstractElements";
import {
  Label,
  Card,
  CardBody,
  CardHeader,
  Collapse,
  Modal,
  ModalBody,
  Badge,
  Button,
} from "reactstrap";
import SweetAlert from "sweetalert2";
import {
  createCategoryMapping,
  deleteCatergoryMapping,
  getCategories,
} from "../../../../../store/slices/categories";
import { useRef } from "react";
import MainMB from "./NewMbComponents/mainMB";

const ProgramMapping = ({reloadData}) => {
  const dispatch = useDispatch();
  const serviceImage = useRef(null);
  const [programListing, setProgramListing] = useState([]);
  const programDetails = useSelector((state) => state.programs.programDetail)??[];
  const _allServices = useSelector((state) => state.services.allServices);
  const allServices = (Array.isArray(_allServices) ? _allServices : []).map(
    (subService) => ({ label: subService?.name, value: subService.slug_name })
  );
  const _allSubServices = useSelector((state) => state.subServices.allSubServices);
  const allSubServices = (Array.isArray(_allSubServices) ? _allSubServices : []).map(
    (subService) => ({ label: subService?.name, value: subService.slug_name })
  );

  const [allCategories, setCategories] = useState([]);

  const [service_slugs, setService_slugs] = useState([]);
  const [subService_slugs, setSubService_slugs] = useState([]);
  const [categories_slugs, setCategories_slugs] = useState([]);

  const [selectedServices, setSelectedService] = useState([]);
  const [selectedSubServices, setSelectedSubService] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const [reload, setReload] = useState(true);

  const [isOpen, setIsOpen] = useState(1);
  const [isPreviewOpen, setIsPreviewOpen] = useState(0);

  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedSubServiceImg, setSelectedSubServiceImg] = useState(null);

  const client = useSelector((state) => state.clients.selectedClient);
  console.log(client, "1111");
  const toggle = (id) => (isOpen === id ? setIsOpen(null) : setIsOpen(id));

  // useEffect(() => {
  //   // Data fetching is handled by ServiceTree which is rendered via MainMB
  // }, [reloadData]);

  const fetchAllServices = () => {
    dispatch(getAllServices());
  };
  const fetchAllSubServices = () => {
    dispatch(getAllSubServices());
  };

  const fetchAllCategories = async () => {
    let data = await dispatch(getCategories());
    // console.log(data, "CATEGORIES");
    const payload = data?.payload;
    const categoriesArray = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.categories)
      ? payload.categories
      : [];
 
    setCategories(
      categoriesArray.map((x) => ({
        label: x.name,
        value: x.slug_name,
      }))
    );
  };

  const getAllProgramsData = async () => {
    let payload = {
      getServiceData: true,
      getSubServiceData: true,
      plan_slug: programDetails.slug_name,
      getFilteredData: true,
      getBySlugName: true,
    };
    let data = await dispatch(getAllPrograms(payload));
    if (data.payload) {
      console.log(data.payload, "Program Data");
      setProgramListing(data.payload[0]);
      setService_slugs(data?.payload[0]?.services?.map((x) => x.slug_name));

      let subService_slugs = data?.payload[0]?.services?.map((x) => {
        return x.sub_services.map((y) => y.slug_name);
      });

      let category_slugs = data?.payload[0]?.services?.map((x) => {
        return x.sub_services.map((y) => y.categories.map((z) => z.slug_name));
      });

      setSubService_slugs(
        subService_slugs.reduce(
          (a, b) => a.concat(Array.isArray(b) ? flatten(b) : b),
          []
        )
      );

      setCategories_slugs(
        category_slugs.reduce(
          (a, b) => a.concat(Array.isArray(b) ? flatten(b) : b),
          []
        )
      );
    }
    setReload(!reload);
  };

  function flatten(ary) {
    return ary.reduce(function (a, b) {
      if (Array.isArray(b)) {
        return a.concat(flatten(b));
      }
      return a.concat(b);
    }, []);
  }

  const handleInput = (event, key) => {
    console.log(event, key, "Events");
    if (key === "service") {
      setSelectedService(event);
    }

    if (key === "subService") {
      setSelectedSubService(event);
    }

    if (key === "categories") {
      setSelectedCategories(event);
    }
  };

  const removeServiceMapping = async (data) => {
    if (await popUp(data?.service_name)) {
      dispatch(deletePrgramServiceMapping({ ID: data?.service_map_id }));
      getAllProgramsData();
    }
  };

  const removeSubServiceMapping = async (data) => {
    if (await popUp(data?.sub_service_name)) {
      dispatch(deleteSubServiceMapping({ ID: data?.sub_service_map_id }));
      getAllProgramsData();
    }
  };

  const popUp = (data) => {
    return SweetAlert.fire({
      title: "Are you sure?",
      text: `You want to delete mapping for ${data}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        return true;
      } else {
        return false;
      }
    });
  };

  const popUp2 = (data) => {
    return SweetAlert.fire({
      title: "Are you sure?",
      text: `You want to create mapping for ${data}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        return true;
      } else {
        return false;
      }
    });
  };

  const createSubServiceMappingData = async (service) => {
    let payload = {
      plan_slug: programDetails.slug_name,
      service_slug: service,
      sub_service_slug: selectedSubServices.map((x) => x.value),
    };
    let data = await dispatch(createSubServiceMapping(payload));
    setSelectedSubService("");
    getAllProgramsData();
  };

  const createProgramServiceMappingData = async (service) => {
    let payload = {
      plan_slug: programDetails.slug_name,
      service_slug: selectedServices.map((x) => x.value),
    };
    let data = await dispatch(createPrgramServiceMapping(payload));
    setSelectedService({});
    getAllProgramsData();
  };

  const createCategorieseMappingData = async (service, sub_service) => {
    let payload = {
      plan_slug: programDetails.slug_name,
      service_slug: service,
      sub_service_slug: sub_service,
      category_slug: selectedCategories.map((x) => x.value),
    };
    let data = await dispatch(createCategoryMapping(payload));
    setSelectedCategories({});
    getAllProgramsData();
  };

  const removeCategoryMapping = async (category) => {
    if (await popUp(category?.category_name)) {
      dispatch(deleteCatergoryMapping({ ID: category.category_map_id }));
      getAllProgramsData();
    }
  };

  const updateSubServiceImage = async (data, e) => {
    console.log(data, "Sub Service Data 2");
    let payload = {
      id: selectedSubServiceImg,
      file: e.target.files[0],
    };

    await dispatch(subServiceImgUpload(payload)).then((res) => {
      if (res?.payload) {
        getAllProgramsData();
      }
    });
  };

  const previewImage = (data) => {
    console.log(data, "Sub Service Data");
    setSelectedImage(data?.service_image);
    setIsPreviewOpen(1);
  };

  console.log(programListing?.services, "programListing?.services");
  return (
    <>
      {
      // client?.value === "hdfc" ? (
        <MainMB programListing={programListing?.services} />
      // ) : (
        // <div>
        //   <Modal
        //     isOpen={isPreviewOpen}
        //     toggle={() => setIsPreviewOpen(!isPreviewOpen)}
        //     size="lg"
        //   >
        //     <ModalBody>
        //       <img
        //         src={`${process.env.REACT_APP_PL_API}/media/media/${selectedImage}`}
        //         alt="img-selected"
        //       ></img>
        //     </ModalBody>
        //   </Modal>
        //   <h1>Program Mapping</h1>
        //   <div>
        //     <div className="d-flex align-items-end">
        //       <div className="w-full me-2">
        //         <Label>Select Service</Label>
        //         <Select
        //           options={
        //             client?.value === "hdfc"
        //               ? allServices
        //               : allServices.filter(
        //                   (x) => !service_slugs.includes(x.value)
        //                 )
        //           }
        //           className="js-example-basic-single text-black col-sm-12"
        //           isMulti
        //           onChange={(e) => handleInput(e, "service")}
        //         />
        //       </div>
        //       <Button
        //         className="bg-primary"
        //         onClick={() => createProgramServiceMappingData()}
        //       >
        //         Save
        //       </Button>
        //     </div>
        //     <div className="mt-4">
        //       {programListing?.services?.map((service, index) => (
        //         <Card
        //           className="w-full p-4  mb-4 bg-light-dark"
        //           key={"programListing" + index}
        //         >
        //           <CardHeader>
        //             <div className="d-flex justify-content-between">
        //               <h4 className="text-black"> {service.service_name}</h4>
        //               <FeatherIcon
        //                 icon="trash-2"
        //                 className="text-danger cursor-pointer ms-1"
        //                 onClick={() => {
        //                   removeServiceMapping(service);
        //                 }}
        //               />
        //             </div>
        //           </CardHeader>
        //           <CardBody className="bg-light-dark">
        //             <div className="mt-2 mb-2 d-flex align-items-end">
        //               <div className="w-full me-2">
        //                 <Label className="text-black">Select Sub Service</Label>
        //                 <Select
        //                   options={
        //                     client?.value === "hdfc"
        //                       ? allSubServices
        //                       : allSubServices.filter(
        //                           (x) => !subService_slugs.includes(x.value)
        //                         )
        //                   }
        //                   className="js-example-basic-single text-black col-sm-12"
        //                   isMulti
        //                   onChange={(e) => handleInput(e, "subService")}
        //                 />
        //               </div>
        //               <Button
        //                 className="bg-primary"
        //                 onClick={() =>
        //                   createSubServiceMappingData(service?.slug_name)
        //                 }
        //               >
        //                 Save
        //               </Button>
        //             </div>
        //             <div className="default-according" id="accordion">
        //               {service?.sub_services.map((subService, subIndex) => (
        //                 <div
        //                   className="d-flex justify-content-center align-items-center"
        //                   key={`sub_services-${subIndex}`}
        //                 >
        //                   <Card className="w-full me-2">
        //                     <CardHeader>
        //                       <H5
        //                         attrH5={{
        //                           className:
        //                             "mb-0 d-flex justify-content-end align-items-center",
        //                         }}
        //                       >
        //                         <Btn
        //                           attrBtn={{
        //                             as: Card.Header,
        //                             className: "btn btn-link",
        //                             color: "default",
        //                             onClick: () => toggle(subIndex),
        //                           }}
        //                         >
        //                           <span>{subService?.sub_service_name}</span>
        //                         </Btn>
        //                         <div className="d-flex align-items-center">
        //                           <FeatherIcon
        //                             icon="eye"
        //                             className="text-danger cursor-pointer me-2"
        //                             onClick={() => {
        //                               previewImage(subService);
        //                             }}
        //                           />
        //                           <FeatherIcon
        //                             icon="image"
        //                             className="text-primary cursor-pointer me-2"
        //                             onClick={() => {
        //                               setSelectedSubServiceImg(
        //                                 subService?.sub_service_map_id
        //                               );
        //                               serviceImage.current.click();
        //                             }}
        //                           ></FeatherIcon>
        //                           <input
        //                             ref={serviceImage}
        //                             type="file"
        //                             accept="image/*"
        //                             className="d-none"
        //                             onChange={(e) =>
        //                               updateSubServiceImage(subService, e)
        //                             }
        //                           ></input>
        //                         </div>
        //                       </H5>
        //                     </CardHeader>
        //                     <Collapse isOpen={isOpen === subIndex}>
        //                       <CardBody>
        //                         <div className="d-flex">
        //                           <div className="w-full me-2">
        //                             <Select
        //                               options={
        //                                 client?.value === "hdfc"
        //                                   ? allCategories
        //                                   : allCategories.filter(
        //                                       (x) =>
        //                                         !categories_slugs.includes(
        //                                           x.value
        //                                         )
        //                                     )
        //                               }
        //                               className=" js-example-basic-single col-sm-12"
        //                               isMulti
        //                               onChange={(e) =>
        //                                 handleInput(e, "categories")
        //                               }
        //                             />
        //                           </div>
        //                           <Button
        //                             className="bg-primary"
        //                             onClick={() =>
        //                               createCategorieseMappingData(
        //                                 service?.slug_name,
        //                                 subService?.slug_name
        //                               )
        //                             }
        //                           >
        //                             Save
        //                           </Button>
        //                         </div>
        //                         <div className="mt-2">
        //                           {subService?.categories?.map(
        //                             (category, index) => (
        //                               <Badge key={"categories" + index}>
        //                                 <div className="d-flex">
        //                                   <h6> {category.category_name}</h6>
        //                                   <FeatherIcon
        //                                     icon="trash-2"
        //                                     className="text-white cursor-pointer ms-4"
        //                                     onClick={() =>
        //                                       removeCategoryMapping(category)
        //                                     }
        //                                   />
        //                                 </div>
        //                               </Badge>
        //                             )
        //                           )}
        //                         </div>
        //                       </CardBody>
        //                     </Collapse>
        //                   </Card>
        //                   <FeatherIcon
        //                     icon="trash-2"
        //                     className="text-danger cursor-pointer ms-1"
        //                     onClick={() => {
        //                       removeSubServiceMapping(subService);
        //                     }}
        //                   />
        //                 </div>
        //               ))}
        //             </div>
        //           </CardBody>
        //         </Card>
        //       ))}
        //     </div>
        //   </div>
        // </div>
      // )
      }
    </>
  );
};

export default ProgramMapping;
